import type { ReactNode } from 'react';
import { Card, theme } from 'antd';

const TONES = { sky: '#0ea5e9', indigo: '#6366f1', green: '#10b981', amber: '#f59e0b', slate: '#64748b' } as const;

interface Props {
  tone: keyof typeof TONES;
  icon: ReactNode;
  label: string;
  value: ReactNode;
}

export function KpiTile({ tone, icon, label, value }: Props) {
  const { token } = theme.useToken();
  return (
    <Card size="small" style={{ flex: '1 1 150px', minWidth: 150 }} styles={{ body: { display: 'flex', gap: 10, alignItems: 'center' } }}>
      <div
        style={{
          width: 34, height: 34, borderRadius: 9, flex: '0 0 auto',
          background: TONES[tone], color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        {icon}
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 12, color: token.colorTextSecondary }}>{label}</div>
        <div style={{ fontSize: 20, fontWeight: 700 }}>{value}</div>
      </div>
    </Card>
  );
}
